module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "payReceiptView"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-default"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "float-right btn btn-sm btn-primary",
    on: {
      "click": function($event) {
        return _vm.printReceiptView()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" Print")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "id": "printReceiptView"
    }
  }, [(_vm.seeRecord) ? _c('div', {
    staticClass: "row printing"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-primary card-outline"
  }, [_c('div', {
    staticClass: "card-body box-profile"
  }, [_c('p', {
    staticClass: "text-bold text-center"
  }, [_vm._v(_vm._s(_vm.getCompanyRecord.companyName) + " "), _c('br'), _vm._v(" Payment Receipt")]), _vm._v(" "), _c('table', {
    staticClass: "table table-condensed center"
  }, [_c('thead', [(_vm.seeRecord.branch) ? _c('tr', [_c('td', [_vm._v("Branch")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.seeRecord.branch.name))])]) : _vm._e()]), _vm._v(" "), _c('tbody', [(_vm.seeRecord.received_by) ? _c('tr', [_c('td', [_vm._v("Agent")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.seeRecord.received_by.name) + " "), (_vm.seeRecord.received_by.code) ? _c('span', [_vm._v("( " + _vm._s(_vm.seeRecord.received_by.code) + " )")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Receipt Date")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.seeRecord.paymentDate))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Receipt No.")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.seeRecord.id))])]), _vm._v(" "), (_vm.seeRecord.type) ? _c('tr', [_c('td', [_vm._v("Type")]), _vm._v(" "), (_vm.seeRecord.type === 'panulty') ? _c('td', [_vm._v("penalty")]) : _c('td', [_vm._v(_vm._s(_vm.seeRecord.type))])]) : _vm._e(), _vm._v(" "), (_vm.seeRecord.member_loan_plan) ? _c('tr', [_c('td', [_vm._v("Loan Id")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.seeRecord.member_loan_plan.applicationNo))])]) : _vm._e(), _vm._v(" "), (_vm.seeRecord.member) ? _c('tr', [_c('td', [_vm._v("Member")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.seeRecord.member.name) + " "), (_vm.seeRecord.member.code) ? _c('span', [_vm._v("( " + _vm._s(_vm.seeRecord.member.code) + " )")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Paid Amount")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.seeRecord.amt))])]), _vm._v(" "), (_vm.seeRecord.branch_ledger) ? _c('tr', [_c('td', [_vm._v("Payment Mode")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.seeRecord.branch_ledger.ledger.name))])]) : _vm._e()])]), _vm._v(" "), _c('p', {
    staticClass: "text-bold"
  }, [_vm._v("Note: This is a computer‐generated document. No signature is required")])])])])]) : _vm._e()]), _vm._v(" "), _vm._m(1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          CLOSE\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cbc5d036!./~/vue-loader/lib/selector.js?type=template&index=0!./src/microfinance/components/PaymentReceipt.vue
// module id = 862
// module chunks = 0